import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-prospectus',
  templateUrl: './prospectus.component.html',
  styleUrls: ['./prospectus.component.scss']
})
export class ProspectusComponent implements OnInit {
  src:string = '/assets/pdf/prospectus 2025 (hindu sr. sec. school).pdf'
  isLoading=true;
  constructor() { }

  ngOnInit(): void {
  }

  hideLoader(){
    this.isLoading=false;
  }
}
